import React from 'react'
import './Loading.css'

function Loading() {
  return (
    <div className="loadingContainer">
      <div className="loadingSpinner">
        <div className="spinner"></div>
      </div>
      <p className="loadingText">Loading...</p>
    </div>
  )
}

export default Loading 